// src/utils/shortlistUtils.js

import { addToShortlist, getShortlistedUsers } from '../Api/CoreApi';
import { message } from 'antd';

let shortlistedIds = [];
let listeners = [];
let isInitialized = false;

export const getShortlistedIds = () => shortlistedIds;

export const addShortlistListener = (callback) => {
    listeners.push(callback);
    return () => {
        listeners = listeners.filter(cb => cb !== callback);
    };
};

const notifyListeners = () => {
    listeners.forEach(callback => callback([...shortlistedIds]));
};

export const fetchShortlistedUsers = async (silent = false) => {
    try {
        console.log("🔄 Fetching shortlisted users...");
        const data = await getShortlistedUsers();
        console.log("📦 Shortlist data:", data);
        
        if (data && Array.isArray(data)) {
            // ✅ Try all possible ID fields
            const newIds = data.map(item => {
                return item.target_user_id || item.user_id || item.User_id || item.id;
            }).filter(Boolean);
            
            console.log("📋 Extracted IDs:", newIds);
            
            if (JSON.stringify(shortlistedIds) !== JSON.stringify(newIds)) {
                shortlistedIds = newIds;
                if (!silent) {
                    notifyListeners();
                }
            }
            isInitialized = true;
            return shortlistedIds;
        } else {
            console.warn("⚠️ Data is not an array:", data);
            if (!silent && shortlistedIds.length === 0) {
                shortlistedIds = [];
                notifyListeners();
            }
            return shortlistedIds || [];
        }
    } catch (error) {
        console.error("❌ Error fetching shortlisted users:", error);
        return shortlistedIds || [];
    }
};

export const handleShortlistUser = async (userId, setShortlistedIdsState) => {
    if (!userId) {
        console.error("❌ No userId provided");
        message.error("Invalid user ID");
        return false;
    }

    try {
        console.log("📌 handleShortlistUser called for userId:", userId);
        const response = await addToShortlist(userId);
        console.log("📥 Add to shortlist response:", response);
        
        // ✅ Check if already shortlisted
        if (response?.already_shortlisted) {
            console.log("ℹ️ Already shortlisted!");
            if (!shortlistedIds.includes(userId)) {
                shortlistedIds.push(userId);
                notifyListeners();
            }
            if (setShortlistedIdsState) {
                setShortlistedIdsState(prev => {
                    if (!prev.includes(userId)) {
                        return [...prev, userId];
                    }
                    return prev;
                });
            }
            message.info("Already shortlisted!");
            return true;
        }
        
        // ✅ Check if successful
        if (response && (response.id || response.target_user_id || response.message || response.success)) {
            if (!shortlistedIds.includes(userId)) {
                shortlistedIds.push(userId);
                notifyListeners();
            }
            
            if (setShortlistedIdsState) {
                setShortlistedIdsState(prev => [...prev, userId]);
            }
            
            await fetchShortlistedUsers(true);
            return true;
        } else {
            // ✅ If we got here but no explicit success, check if already in list
            if (shortlistedIds.includes(userId)) {
                console.log("ℹ️ User already in shortlist");
                return true;
            }
        }
        
        console.warn("⚠️ Unexpected response:", response);
        return false;
        
    } catch (error) {
        console.error("❌ Shortlist error:", error);
        
        // ✅ If error says already shortlisted
        if (error?.response?.data?.message === "Already shortlisted" || 
            error?.response?.data?.detail?.includes("already")) {
            if (!shortlistedIds.includes(userId)) {
                shortlistedIds.push(userId);
                notifyListeners();
            }
            if (setShortlistedIdsState) {
                setShortlistedIdsState(prev => {
                    if (!prev.includes(userId)) {
                        return [...prev, userId];
                    }
                    return prev;
                });
            }
            message.info("Already shortlisted!");
            return true;
        }
        
        message.error(error?.response?.data?.detail || error?.message || "Failed to shortlist user");
        return false;
    }
};

// Initialize only once
if (!isInitialized) {
    fetchShortlistedUsers(true);
}